import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state type
interface StoreState {
  enthusiasmLevel: number;
  languageName: string;
}

// Initial state
const initialState: StoreState = {
  enthusiasmLevel: 1,
  languageName: 'TypeScript',
};

// Create a slice
const enthusiasmSlice = createSlice({
  name: 'enthusiasm',
  initialState,
  reducers: {
    increment: (state) => {
      state.enthusiasmLevel += 1;
    },
    decrement: (state) => {
      state.enthusiasmLevel = Math.max(1, state.enthusiasmLevel - 1);
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.languageName = action.payload;
    },
  },
});

// Export actions
export const { increment, decrement, setLanguage } = enthusiasmSlice.actions;

// Export reducer
export default enthusiasmSlice.reducer;
